import React, { Component } from 'react';
import $ from 'jquery';
import '../css/dataTables.css';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ContactPersons } from './NewOrder';
import { QueryModel } from './NewOrder';
import { QueryPreviewManagerModal } from "../components";
import { ApiClient } from "../libs/apiClient";
import Table from '../components/Table';
import { CSVLink, CSVDownload } from "react-csv";
import moment from "moment";
import { json } from '../libs/utils/Const';
import ExportPdf from './ExportPDF';
let headers = [
    { title: 'Tabla' }
];
let condiciones = [
    { title: 'Igual a', value: '=[' },
    { title: 'Mayor que', value: '>' },
    { title: 'Menor que', value: '<' },
    { title: 'Superior/Igual', value: '>=[' },
    { title: 'Menor/Igual', value: '<=' },
    { title: 'No igual a', value: '<>' },
    { title: 'Contiene', value: "Like'%%_%%'" },
    { title: 'No contiene', value: "NOT Like '%%_%%'" },
    { title: 'Comienza con', value: "Like'_%%'" },
    { title: 'Finaliza con', value: "Like'%%_'" },
    { title: 'IS NULL', value: 'IS NULL' },
    { title: 'IS NOT NULL', value: 'IS NOT NULL' },
    { title: 'O bien', value: 'OR' },
    { title: 'Y', value: 'AND' }
];
let apiClient = ApiClient.getInstance();

class CreateQueryManagerModal extends Component {
    csvLink = React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            queryModel: {},
            table: [],
            Columns: [],
            header: [],
            switch1: false,
            selection: '',
            subCategories: [],
            originSubCategories: [],
            searchValue: '',
            fieldsModal: [],
            docType: '',
            tableToExcel: []
        };
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount = async () => {
        const { showAlert, enableSpinner } = this.props;
        let queryModel = new QueryModel();
        enableSpinner(true);
        let getSelectQueryResponse = await apiClient.getSelectsQueryManager(json.userFieldsQueryManager);
        enableSpinner(false);
        if (getSelectQueryResponse.status) {
            for (let index = 0; index < json.userFieldsQueryManager.length; index++) {
                const field = json.userFieldsQueryManager[index];
                for (let indexy = 0; indexy < getSelectQueryResponse.data.length; indexy++) {
                    const fieldResult = getSelectQueryResponse.data[indexy];
                    if (field.name === fieldResult.name) {
                        field.options = fieldResult.options;
                    }
                }
            }
        }

        this.setState({
            queryModel
        });
    }

    closeQuery = async () => {
        const { queryModel } = this.state;
        queryModel.query = '';
        queryModel.queryName = '';
        this.refreshModel(queryModel);
        this.setState({
            table: []
        });
        $('#queryManagerModal').modal('hide');

    };

    closeAction = () => {
        const { queryModel } = this.state;
        queryModel.query = '';
        queryModel.queryName = '';
        this.refreshModel(queryModel);
        $('#queryManagerModal').on('hide.bs.modal', function () {
            this.setState({
                table: []
            });
        });
    };

    ShowPreview = async () => {
        const { queryModel } = this.state;
        const { showAlert, enableSpinner, fieldsModal } = this.props;

        let query = queryModel.query || '';
        let data = {
            Squery: query
        }
        enableSpinner(true);
        let getQueryResponse = await apiClient.createQuery(data);
        enableSpinner(false);

        if (!Array.isArray(getQueryResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getQueryResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No se encontraron resultados coincidentes para su búsqueda' });
            return;
        }

        this.setState({
            table: getQueryResponse.data
        });
    };

    GenerateCsv = async () => {
        const { queryModel } = this.state;
        const { showAlert, enableSpinner } = this.props;

        let query = queryModel.query || '';
        let data = {
            Squery: query
        }
        enableSpinner(true);
        let getQueryResponse = await apiClient.createQuery(data);
        enableSpinner(false);

        if (!Array.isArray(getQueryResponse.data)) {
            this.setState({ fieldsModal: [] })
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getQueryResponse.data.length === 0) {
            this.setState({ fieldsModal: [] })
            showAlert({ type: 'info', message: 'No se encontraron resultados coincidentes para su búsqueda' });
            return;
        }

        getQueryResponse.data.map(query => {
            for (const property in query) {
                let formattedProperty = property.toString().toLowerCase();
                if (query[property] && (formattedProperty.includes('fecha') || formattedProperty.includes('date')) && (query[property].toString().includes("2020-") || query[property].toString().includes("2021-"))) {
                    // Hay que usar UTC o quita (-1 dia) Subí esto a las 10:40pm Cambio Cjj
                    query[property] = moment(query[property]).utc().format('YYYY-MM-DD');
                }
            }
        });

        this.setState({ tableToExcel: getQueryResponse.data, fieldsModal: [] })
        setTimeout(() => {
            this.csvLink.current.link.click();
        }, 500);
    };

    GenerateReporte = async () => {
        const { queryModel } = this.state;
        const { showAlert, enableSpinner } = this.props;

        let query = queryModel.query || '';
        let data = {
            Squery: query
        }


        enableSpinner(true);
        let getQueryResponse = await apiClient.createQuery(data);
        enableSpinner(false);
        if (!Array.isArray(getQueryResponse.data)) {
            this.setState({ fieldsModal: [] })
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getQueryResponse.data.length === 0) {
            this.setState({ fieldsModal: [] })
            showAlert({ type: 'info', message: 'No se encontraron resultados coincidentes para su búsqueda' });
            return;
        }

        getQueryResponse.data.map(query => {
            for (const property in query) {
                let formattedProperty = property.toString().toLowerCase();
                if (query[property] && (formattedProperty.includes('fecha') || formattedProperty.includes('date')) && (query[property].toString().includes("2020-") || query[property].toString().includes("2021-"))) {
                    // Hay que usar UTC o quita (-1 dia) Subí esto a las 10:40pm Cambio Cjj
                    query[property] = moment(query[property]).utc().format('YYYY-MM-DD');
                }
            }
        });

        // this.setState({ tableToExcel: getQueryResponse.data, fieldsModal : []})
        // setTimeout(() => {
        //         this.csvLink.current.link.click();
        // }, 500); 
    };

    changeSelects = async (event) => {
        const { showAlert, enableSpinner } = this.props;
        let selectCategory = event.nativeEvent.target.value;

        if (selectCategory !== 'N') {
            enableSpinner(true);
            let getQueryManagerResponse = await apiClient.getSearchFormaterSubCategories(selectCategory);
            enableSpinner(false);

            if (!Array.isArray(getQueryManagerResponse.data)) {
                showAlert({ type: 'info', message: getQueryManagerResponse.message });
                return;
            }
            if (getQueryManagerResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
            this.setState({
                originSubCategories: getQueryManagerResponse.data,
                subCategories: getQueryManagerResponse.data,
                selection: selectCategory,
                queryModel: {},
                table: [],
                Columns: [],
                searchValue: ''
            });
        } else {
            this.setState({
                originSubCategories: [],
                subCategories: [],
                selection: [],
                queryModel: {},
                table: [],
                Columns: [],
                searchValue: ''
            });
        }
    };

    changeSelected = (event) => {
        const { queryModel, subCategories } = this.state;
        let intrnalKey = event.nativeEvent.target.value;

        subCategories.map((objeto) => {
            if (intrnalKey == objeto.IntrnalKey) {
                queryModel.queryName = objeto.QName || '';
                queryModel.query = objeto.QString || '';
            }
        });
        this.buscarCondicion(queryModel.query);
        // --------------------------------------

        let query = queryModel.query || '';

        // //g significa global, sino solo toma el 1er valor encontrado
        function escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }

        let parameters = ["fmb0", "fmb1", "fmb2", "fmb3", "fmb4", "fmb5", "fmb6", "fmb7", "fmb8", "fmb9",
            "fmb10", "fmb11", "fmb12", "fmb13", "fmb14", "fmb15", "fmb16", "fmb17"];
        let queryParameters = query;
        let fieldsModal = [];
        if (query.includes("[%")) {
            // Ciclo para parametros
            for (var c = 0; c < parameters.length; c++) {
                queryParameters = queryParameters.replace(new RegExp(escapeRegExp("[%" + c + "]"), 'g'), parameters[c]);
            }

            // Ciclo para posiciones donde hay parametros
            let queryIndex = [];
            let queryField = queryParameters;
            let parameterAndField = "";
            let field = "";
            let parameter = "";
            for (var d = 0; d < parameters.length; d++) {
                let coincidence = queryField.indexOf(parameters[d]);
                if (coincidence !== -1) {
                    parameterAndField = queryField.substring(coincidence + 5, queryField.lastIndexOf('.', coincidence + 5) + 1);
                    field = parameterAndField.substring(parameterAndField, parameterAndField.indexOf(" ", parameterAndField));
                    queryIndex.push(field);
                }
            }

            parameters.map((fmb, index) => {
                let data = {
                    varName: fmb,
                    fieldsName: queryIndex[index] || null,
                    description: "",
                    var: null,
                    type: "",
                    options: []
                }
                fieldsModal.push(data);
            });
            queryModel.query = queryParameters;
        }
        //---------------------------------------------
        this.refreshModel(queryModel);
        this.setState({
            header: subCategories,
            table: [],
            Columns: [],
            fieldsModal: fieldsModal
        });
    };

    buscarCondicion = (query) => {
        let wherePosition = query.indexOf('WHERE');
        condiciones.map((condicion) => {
            let con = condicion.value;
            var posicion = query.indexOf(con);

            if (posicion > wherePosition) {

            }

        });
    }

    handleSwitchChange = nr => () => {
        let switchNumbers = `switch${nr}`;
        this.setState({
            switch1: !this.state[switchNumbers]
        });

    }

    changeQuery = (event) => {
        const { queryModel } = this.state;
        queryModel.query = event.nativeEvent.target.value;
        this.refreshModel(queryModel);
    };

    refreshModel = queryModel => {
        this.setState({
            queryModel
        });
    };

    handleSearch = (event) => {
        const { queryModel, originSubCategories, searchValue, subCategories } = this.state;
        let search = event.nativeEvent.target.value.toLowerCase();
        let matches = [];

        if (search !== '') {
            matches = originSubCategories.filter(subCat => subCat.QName.toLowerCase().includes(search));
            this.setState({
                subCategories: matches,
                searchValue: search
            });
        } else {
            this.setState({
                subCategories: originSubCategories,
                searchValue: ''
            });
        }
    };

    changeParams = async (index, event) => {
        const { fieldsModal } = this.state;
        const { showAlert, enableSpinner } = this.props;

        if (event.nativeEvent.data !== '') {
            fieldsModal[index].var = event.nativeEvent.target.value;
        }

        this.setState({
            fieldsModal
        });
    };

    changeParams2 = async (index, value) => {
        const { fieldsModal } = this.state;
        const { showAlert, enableSpinner } = this.props;

        if (value !== '' && value !== null && value !== undefined) {
            fieldsModal[index].var = value;
        }

        this.setState({
            fieldsModal
        });
    };

    validateParams = (param) => {
        const { fieldsModal } = this.state;
        this.setState({
            docType: param
        });
        let flag = false;
        fieldsModal.map(param => {
            if (param.varName) {
                flag = true;
            }
        });

        if (flag) {
            $('#modalParams').modal('show');
        } else {
            if (param === 1) {
                this.ShowPreview();
            } else if (param === 2) {
                this.GenerateCsv();
            }

        }

    }

    CreateReport = () => {
        $('#modalReport').modal('show');
    }

    saveParams = () => {
        const { fieldsModal, queryModel, docType } = this.state
        // Comparacion y reemplazo con parametros
        function escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
        //queryModel.query = queryModel.query.replace(/["']/g, "");
        // Reemplaza palabras
        for (var c = 0; c < fieldsModal.length; c++) {
            queryModel.query = queryModel.query.replace(new RegExp(escapeRegExp(fieldsModal[c].varName), 'g'), `'${fieldsModal[c].var}'`);
        }
        // Reemplaza comillas dobles
        for (var c = 0; c < fieldsModal.length; c++) {
            queryModel.query = queryModel.query.replace(new RegExp(escapeRegExp(`''${fieldsModal[c].var}''`), 'g'), `'${fieldsModal[c].var}'`);
        }

        this.setState({
            queryModel
        });
        $('#modalParams').modal('hide');
        setTimeout(() => {
            if (docType === 1) {
                this.ShowPreview();
            } else if (docType === 2) {
                this.GenerateCsv();
            } else if (docType === 3) {
                this.GenerateReporte();
            }


        }, 500);
    }

    renderQueryHeader = () => {
        const { query } = this.props;
        const { queryModel, subCategories, searchValue } = this.state;
        let searchFormater = query.searchFormater ? query.searchFormater : [];

        return (
            <div className="tab-content" >
                <div className="card" style={{ background: 'transparent' }}>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-4 mb-3">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <label className="input-group-text"> <i className="fa fa-search"></i></label>
                                        </div>
                                        <select id="general" className="form-control btn-outline-secondary"
                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                            onChange={(event) => this.changeSelects(event)}>
                                            <option selected="selected" value={'N'}>{'Categorías'}</option>
                                            {(searchFormater.map(objeto => {
                                                return (
                                                    <option value={objeto.CategoryId}>{objeto.CatName}</option>
                                                )
                                            }))}
                                        </select>
                                    </div>

                                <div className="row mx-auto justify-content-center">
                                    <label htmlFor="txtConsulta" className="font-weight-bold">
                                        Nombre de la consulta
                                    </label>
                                </div>
                                <div className="row">
                                    <input
                                        type="text"
                                        className="form-control input-md"
                                        id="txtConsulta"
                                        value={queryModel.queryName || ''}
                                        disabled={true} />
                                </div>
                            </div>
                            <div className="col-12 col-md-12 col-lg-7 mb-3">
                                <div className="mb-2">
                                    <input className="form-control form-control-sm" type="text" placeholder="Buscar"
                                        onChange={(event) => this.handleSearch(event)} value={(searchValue || '')} />
                                </div>
                                <div>
                                    <select multiple id="querySelector" className="form-control btn-outline-secondary hover consulta-responsive" size="8"
                                        style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                        onChange={(event) => this.changeSelected(event)}>
                                        {subCategories.map(objeto => {
                                            return (
                                                <option value={objeto.IntrnalKey}>{objeto.QName}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    renderQueryBody = () => {
        const { queryModel, switch1, table } = this.state;

        return (

            <div className="tab-content" >
                <div className="card" style={{ background: 'transparent' }}>
                    <div className="card-body">
                        <div className="row">
                            {/* <div className=" col-md-6">
                                            <label className="col-form-label font-weight-bold" >
                                                Editar 
                                            </label>
                                            &nbsp;&nbsp;
                                            <label className="switch" >
                                                <input type="checkbox"  
                                                 checked={switch1} 
                                                onChange={this.handleSwitchChange(1)}
                                                />
                                                <span className="slider round"></span>
                                            </label>
                                    </div> */}

                            <div className="col-md-12 col-sm-12">
                                <textarea
                                    type="text"
                                    className=" form-control btn-outline-secondary"
                                    id="txtQuery"
                                    rows="4"
                                    cols="100"
                                    value={queryModel.query || ''}
                                    onChange={event => this.changeQuery(event)}
                                    disabled={!switch1}
                                    style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                />
                                <br></br>
                            </div>

                            <div className="col-md-12 col-sm-12">
                                <Table data={table} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    copy = () => {
        const { showAlert } = this.props;

        var codigoACopiar = document.getElementById('dataTableQuery');    //Elemento a copiar
        //Debe estar seleccionado en la página para que surta efecto, así que...
        var seleccion = document.createRange(); //Creo una nueva selección vacía
        seleccion.selectNodeContents(codigoACopiar);    //incluyo el nodo en la selección
        //Antes de añadir el intervalo de selección a la selección actual, elimino otros que pudieran existir (sino no funciona en Edge)
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(seleccion);  //Y la añado a lo seleccionado actualmente
        try {
            var res = document.execCommand('copy'); //Intento el copiado

            if (res) {
                showAlert({ type: 'info', message: 'Información copiada' });
            }
        }
        catch (ex) {
            showAlert({ type: 'error', message: 'Ocurrió un error copiar la Información' });
        }
        window.getSelection().removeRange(seleccion);

    }

    render() {

        const { fieldsModal, table, queryModel, tableToExcel } = this.state
        let today = moment(new Date()).format('YYYY-MM-DD_hmm');
        let date = moment(new Date()).format('YYYY-MM-DD');
        let value = "";
        let QueryName = queryModel ? queryModel.queryName : '';
        let result = table.length;

        return (
            <div>
                <div className="modal fade bd-example-modal-lg bgtransparent" id="queryManagerModal" style={{ zIndex: 91 }} role="dialog"
                    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <QueryPreviewManagerModal titleModal={'Nuevo'} />
                    <CSVLink
                        data={tableToExcel}
                        filename={`Consulta${today}.csv`}
                        className="hidden"
                        ref={this.csvLink}
                        target="_blank">
                    </CSVLink>
                    <div className="modal-dialog modal-lg " role="document">
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Query Manager</h4>
                                <button type="button" className="close" onClick={this.closeQuery} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row">
                                        <div className="col-md-12">{this.renderQueryHeader()}</div>
                                        <div className="col-md-12">{this.renderQueryBody()}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                               <div className="row w-100">
                                <div className="col-12 col-md-10">
                                    <div className="d-flex flex-wrap gap-2">
                                    {/*  data-target=".modalitems" */}
                                    <button className="btn btn-success text-white btn-outline-secondary mr-sm-2 mb-2" style={{ borderColor: "#A7A6A5" }} onClick={() => this.validateParams(2)}> <i className="fa fa-file-excel-o mr-sm-1"></i>
                                        Generar reportes
                                    </button>
                                    <button type="button" className="btn botonCerrar text-white mr-sm-2 mb-2 ml-2" data-toggle="modal" onClick={() => this.validateParams(1)} >Ejecutar</button>

                                    <button type="button" className="btn botonCorrect text-black mr-sm-2 mb-2 ml-1" style={{ textAlign: 'left' }} onClick={this.copy}>Copiar datos</button>

                                    {/* <button type="button" className="btn botonCorrect text-black mr-sm-2"  style={{textAlign:'left'}} onClick={() =>this.CreateReport()}>Generar reporte</button> */}

                                    {QueryName === 'Bitacora de Clientes' && result > 0 && <ExportPdf date={date} fields={fieldsModal} data={table} />}
                                </div>
                                </div>
                                <div className="col-md-2" style={{ textAlign: 'right' }}>

                                    <button type="button" className="btn botonCerrar text-white" onClick={this.closeQuery} >Cerrar</button>
                              </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade modalitems" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" id="modalParams" style={{ top: '20%' }}
                    aria-hidden="true">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content" style={{ position: 'center' }}>
                            <div className="modal-content">

                                <div className="modal-header text-white" style={{ background: '#343a40', borderRadius: '0' }}>
                                    <h5 className="modal-title" id="modal-basic-title ">Agregar campos</h5>

                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" className="text-white">&times;</span>
                                    </button>
                                </div>

                                <div className="modal-body">
                                    <div className="contanier">

                                        {fieldsModal.map((inp, index) => {


                                            json.userFieldsQueryManager.map((item) => {
                                                if (item.name === "\"PrjCode\"") item.name = "\"Project\""
                                                if (inp.fieldsName === item.name) {
                                                    inp.description = item.description;
                                                    if (item.fieldType === 1) {
                                                        inp.type = "text"
                                                    }
                                                    else if (item.fieldType === 2) {
                                                        inp.type = "select";
                                                        inp.options = item.options;

                                                    } else if (item.fieldType === 3) {
                                                        inp.type = "date"
                                                    }
                                                }
                                            })
                                            return (
                                                <div className="row mx-auto justity-content-center">
                                                    {(inp.fieldsName) && (
                                                        <div className="row mx-auto justity-content-center">
                                                            <div className="col-12 col-md-6">
                                                                <div className="input-group mb-3">
                                                                    <div className="input-group-prepend">
                                                                        <span className="input-group-text font-weight-bold">{inp.description}</span>
                                                                    </div>
                                                                    {(inp.type === 'text' || inp.type === 'date') && (
                                                                        <input
                                                                            type={inp.type}
                                                                            className="form-control"
                                                                            id="txtName"
                                                                            value={inp.var || ''}
                                                                            onChange={event => this.changeParams(index, event)}
                                                                        //value={newOrderModel.CardName ? newOrderModel.CardName : ''}
                                                                        />
                                                                    )}
                                                                    {
                                                                        (inp.type === 'select') && (

                                                                            <Autocomplete
                                                                                id="custom-input-demo"
                                                                                options={inp.options}
                                                                                className="form-control"
                                                                                onChange={(event, value) => this.changeParams2(index, value)}
                                                                                renderInput={(params) => (
                                                                                    <div ref={params.InputProps.ref}>
                                                                                        <input className="form-control" placeholder="Opciónes..." type="text" {...params.inputProps} />
                                                                                    </div>
                                                                                )}
                                                                            />

                                                                        )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        })
                                        }
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn btn-success float-right" onClick={this.saveParams} >OK</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade modalitems" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" id="modalReport" style={{ top: '10%' }}
                    aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content" style={{ position: 'center' }}>
                            <div className="modal-content">

                                <div className="modal-header text-white" style={{ background: '#343a40', borderRadius: '0' }}>
                                    <h5 className="modal-title" id="modal-basic-title ">Reporte</h5>

                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" className="text-white">&times;</span>
                                    </button>
                                </div>

                                <div className="modal-body">
                                    <div className="contanier">

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>


        );
    }
}

export default CreateQueryManagerModal;